import React from 'react'

const Marker = ({ text, color }) => {
    return (
        <span className="pin" style={{ background: color }}>{text}</span>
    );
}

export default Marker;